import React, {useEffect, useState } from 'react'
import Header from '../../components/Header'
import Footer from '../../components/Footer'
import { Link } from 'react-router-dom'
import Common_form from '../../components/Common_form'
import { AiFillHome, AiOutlineAppstore } from 'react-icons/ai'
import LoginModal from '../../components/LoginModel'; // Import the modal
import { useAuth } from '../../context/auth'; // Import the useAuth hook

const MediationAndArbitration = () => {
  const [isModalOpen, setIsModalOpen] = useState(false); // State for modal visibility
  const [auth] = useAuth(); // Access auth state from context
  const isLoggedIn = Boolean(auth.token); // Determine if user is logged in based on token

  useEffect(() => {
    // Show the modal if the user is not logged in
    if (!isLoggedIn) {
      setIsModalOpen(true); // Show the modal if not logged in
    }
  }, [isLoggedIn]); // Run effect whenever isLoggedIn changes

  const closeModal = () => {
    setIsModalOpen(false); // Function to close modal
  };

  return (
    <div className='bg-slate-100'>
      <Header />
      {/* Page Title */}
      <div className="page-title py-6 bg-slate-300" data-aos="fade">
        <div className="container mx-auto px-4 lg:px-20 flex flex-col lg:flex-row justify-between items-start lg:items-center">
          {/* Title */}
          <h1 className=" text-black text-xl md:text-2xl font-semibold">Legal Notice</h1>

          {/* Refund message */}
          <style jsx>{`
      @keyframes intenseBlink {
        0%, 100% { opacity: 1; color: #f20000; }
        20% { opacity: 1; color: #000000; }
      }
    `}</style>
          <h1
            className="
        text-lg md:text-xl font-bold underline underline-offset-8 
        mb-2 lg:mb-0 lg:ml-4 
        animate-[intenseBlink_1s_ease-in-out_infinite]
      "
          >
            100% Fees Refundable, if Service is not Completed!
          </h1>

          {/* Breadcrumbs */}
          <nav className="breadcrumbs mt-2 lg:mt-0">
            <ol className="flex space-x-2 lg:space-x-4 text-sm items-center">
              <li className="flex items-center">
                <AiFillHome className="mr-1 text-base hover:underline" />
                <Link to={'/'} className="text-black hover:underline text-base">Home</Link>
              </li>
              <li className="text-black">/</li>
              <li className="flex items-center">
                <AiOutlineAppstore className="mr-1 text-base" />
                <Link to={'/all_service'} className="text-black hover:underline text-base">All Services</Link>
              </li>
            </ol>
          </nav>
        </div>
      </div>
      <div className="container mx-auto px-4 lg:px-16 py-8">
      <div className="text-center mb-8">
  <h2 className="text-2xl lg:text-3xl font-bold border-b-4 border-red-600 inline-block pb-2">
    Mediation & Arbitration
  </h2>
  <h3 className="pt-4 text-base font-semibold">
    Alternative Dispute Resolution | Effective & Legally Binding Solutions
  </h3>
  <p className="pt-4">
    **Mediation and Arbitration** are alternative dispute resolution (ADR) methods that provide efficient, cost-effective, and legally binding solutions to conflicts without the need for litigation. These methods help parties resolve disputes amicably while maintaining confidentiality and flexibility.
  </p>
  <p className="pt-4">
    **Mediation** involves a neutral third party (mediator) who facilitates discussions between disputing parties to help them reach a mutually acceptable settlement. It is voluntary, non-binding, and focuses on preserving relationships.
  </p>
  <p className="pt-4">
    **Arbitration**, on the other hand, is a more structured process where a neutral arbitrator hears both sides and makes a binding decision based on evidence and legal principles. It is commonly used in commercial, employment, and contract disputes.
  </p>
  <p className="pt-4">
    Our expert mediation and arbitration services ensure fair, impartial, and legally sound resolutions while saving time and legal expenses.
  </p>
</div>

        <hr class="h-px my-9 bg-gray-700 border-none dark:bg-gray-700" />
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          {/* Left side - Form */}

          <Common_form application_type="MediationAndArbitration" />

          {/* Right side - Content */}
          <div className='bg-slate-200 p-3'>
  <h1 className="text-2xl font-bold mb-4">
    What is Mediation & Arbitration? What purpose do they serve?
  </h1>
  <p className="mb-4">
    **Mediation and Arbitration** are alternative dispute resolution (ADR) methods that help individuals and businesses settle disputes efficiently without going to court. These methods aim to provide cost-effective, time-saving, and legally recognized solutions.
  </p>
  
  <h2 className="text-xl font-semibold mb-2">When to Choose Mediation?</h2>
  <p>
    **Mediation** is a voluntary process where a neutral third party (mediator) helps disputing parties communicate and negotiate a mutually acceptable resolution. It is commonly used in:
    <br />
    • **Family and Divorce Disputes** – Settling child custody, alimony, and property division amicably.
    <br />
    • **Business and Contract Disputes** – Resolving partnership conflicts, breach of contract, and service agreements.
    <br />
    • **Workplace Disputes** – Addressing employer-employee disagreements and workplace conflicts.
  </p>

  <h2 className="text-xl font-semibold mb-2">When to Choose Arbitration?</h2>
  <p>
    **Arbitration** is a structured process where a neutral arbitrator reviews evidence and makes a legally binding decision. It is suitable for:
    <br />
    • **Commercial Disputes** – Used in business contracts to resolve disputes outside court.
    <br />
    • **Consumer Complaints** – Addressing grievances against service providers and companies.
    <br />
    • **International Disputes** – Commonly used in cross-border trade agreements.
  </p>

  <p className="mt-4">
    Our expert mediation and arbitration services provide fair, impartial, and legally sound resolutions, ensuring smooth conflict resolution while avoiding prolonged litigation.
  </p>
</div>

        </div>
      </div>
  {/* Render Login Modal only if not logged in */}
  {!isLoggedIn && isModalOpen && <LoginModal closeModal={closeModal} />}
      <Footer />
    </div>
  )
}

export default MediationAndArbitration;
